export const breakpoints = {
    sm: 'screen and (min-width: 600px)',
    md: 'screen and (min-width: 900px)',
    lg: 'screen and (min-width: 1160px)',
    xl: 'screen and (min-width: 1400px)',
} as const;
